import { render, staticRenderFns } from "./ProfileRight.vue?vue&type=template&id=1873b5ec&"
import script from "./ProfileRight.vue?vue&type=script&lang=ts&"
export * from "./ProfileRight.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../namtrung_logistics/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports